export const ALL = 'All';
export const MAJOR = 'Major';
export const MINOR = 'Minor';
export const SHARP = 'Sharp';
export const FLAT = 'Flat';

export const CHORD_FILTER_LIST = [ALL, MAJOR, MINOR, SHARP, FLAT];
